module.exports = __webpack_public_path__ + "img/Broken Clasp.1d0d87e5.png";